import { RESPONSE_TYPES } from "@constants/response-types";
import { HttpService } from "@services/http";
import {
  prepareErrorResponse,
  prepareResponseObject,
} from "@services/http/response";
import { AxiosResponse } from "axios";

export class AppService extends HttpService {
  fetchSuggestedQuestions = async (
    baseAuthUrl: string
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.get(
        `${baseAuthUrl}/api/suggestion-questions`
      );

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  fetchFaqs = async (baseAuthUrl: string, payload: any) => {
    try {
      const { data } = await this.get(`${baseAuthUrl}/api/faqs`, payload);

      return data?.data;
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  logEvent = async (baseAuthUrl: string, data: any): Promise<TObject> => {
    try {
      const apiResponse = await this.post(
        `${baseAuthUrl}/api/event-logs`,
        data
      );

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };

  getReports = async (baseAuthUrl: string, payload: any) => {
    try {
      const { data } = await this.get(`${baseAuthUrl}/api/reports`, payload);
      return data?.data;
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };
}
